import { pluralize } from '~utils/commons';

export const VALIDATIONS_ERROR = {
  REQUIRED: 'Campo requerido',
  EMAIL: 'El email es inválido',
  PASSWORD_NOT_MATCH: 'La contraseñas no coinciden',
  INVALID_DATE: 'Fecha invalida',
  MIN: (val: number): string => `Debe ser mayor o igual que ${val}`,
  MORE_THAN: (val: number): string => `Debe ser mayor que ${val}`,
  MIN_LENGTH: (val: number): string =>
    `Longitud mínima  de ${pluralize({
      singular: 'carácter',
      plural: 'caracteres',
      count: val,
      includeCount: true,
    })}`,
  PHONE: 'El formato de teléfono es inválido',
  URL: 'El formato de URL es inválido',
};
